export default "/kiban/_next/static/images/matteBlack-0fbf56f8c834a83da4ddd112b0eb861b.png";